export default "__VITE_ASSET__3I8URm1W__"